var r = /* @__PURE__ */ (function(n) {
  return n.success = "success", n.error = "error", n.warning = "warning", n.info = "info", n.image = "image", n.none = "none", n;
})(r || {});
export {
  r as DialogTypes
};

//# sourceMappingURL=Dialog.types.js.map